module.exports = __webpack_public_path__ + "static/media/upl.8772dc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/logos/upl.png
// module id = 2896
// module chunks = 3